import { z } from "zod";

import { getPhoneValidationError } from "../../../utils/phoneValidation";
import { DEFAULT_ISD_CODE } from "../../../constants/constants";

export const agentPhoneSearchSchema = z
  .object({
    phone: z.preprocess(
      (val) => (val === undefined ? "" : val),
      z.string().min(1, "Phone number is required"),
    ),
  })
  .superRefine((data, ctx) => {
    const phoneError = getPhoneValidationError(data.phone, DEFAULT_ISD_CODE);
    if (phoneError) {
      ctx.addIssue({
        code: "invalid_type",
        message: phoneError,
        path: ["phone"],
      });
    }
  });
